/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiIdentifyUserRequestFromJSON(json) {
    return StreemApiIdentifyUserRequestFromJSONTyped(json, false);
}
export function StreemApiIdentifyUserRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'deviceSid': !exists(json, 'device_sid') ? undefined : json['device_sid'],
        'isExpert': !exists(json, 'is_expert') ? undefined : json['is_expert'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'avatarUrl': !exists(json, 'avatar_url') ? undefined : json['avatar_url'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
    };
}
export function StreemApiIdentifyUserRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'device_sid': value.deviceSid,
        'is_expert': value.isExpert,
        'email': value.email,
        'name': value.name,
        'avatar_url': value.avatarUrl,
        'phone': value.phone,
    };
}
//# sourceMappingURL=StreemApiIdentifyUserRequest.js.map